import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteReplacementTransportOptionById,
  fetchReplacementTransportOptionById,
} from "../../../../lib/api/resources/replacementTransports";
import { ReplacementTransportOptionDetailCard } from "./components/ReplacementTransportOptionDetailCard";

export const ReplacementTransportOptionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const replacementTransportOptionQuery = useQuery({
    queryKey: ["replacementTransportOption", id],
    queryFn: () => fetchReplacementTransportOptionById(id),
  });

  const deleteReplacementTransportOptionMutation = useMutation({
    mutationFn: () => deleteReplacementTransportOptionById(id),
    onSuccess: () => {
      navigate(`/replacement-transport/options`);
      message.success("Vervangend vervoer optie succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de vervangend vervoer optie",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ReplacementTransportOptionDetailCard
              deleteMutation={deleteReplacementTransportOptionMutation}
              replacementTransportOption={replacementTransportOptionQuery.data}
              isLoading={replacementTransportOptionQuery.isFetching}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
